import styled from "styled-components";

export const Header = styled.div`
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  border: 1px solid lightgray;
  position: fixed;
  z-index: 100;
  background: white;
  width: 82%;
  margin: 0 15px;
  -webkit-box-shadow: 0px 0px 100px 32px rgb(0 0 0 / 75%);
  -moz-box-shadow: 0px 0px 100px 32px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 0px 11px 10px rgb(0 0 0 / 20%);

  @media (min-width: 1000px) {
    width: 82%;
    padding: 20px;
    margin: 0;
  }
`;

export const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  > h4 {
    display: flex;
    text-transform: lowercase;
    margin-right: 10px;
  }
  > h4 > svg {
    margin-left: 10px;
    font-size: 18px;
  }
`;

export const HeaderRight = styled.div`
  > p {
    display: flex;
    align-items: center;
    font-size: 14px;
  }

  > p > svg {
    margin-right: 5px !important;
    font-size: 16px;
  }
`;

export const ChatContainer = styled.div`
  background-color: white;
  flex-grow: 1;
  overflow-y: scroll;
  margin-top: 70px;
  -ms-overflow-style: none;
  scrollbar-width: none;
  ::-webkit-scrollbar {
    display: none;
  }
  
  @media (min-width: 1000px) {
    margin-left: 14%;
    width: 70%;
  }
`;

export const ChatMessages = styled.div`
  margin-top: 70px;
`;

export const ChatBottom = styled.div`
  padding-bottom: 100px;
`;

export const EmptyChannel = styled.div`
  height: calc(100vh - 240px);
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 20px;
  color: var(--slack-color);
`;
